export default __webpack_public_path__ + "static/media/curved-arrow-right.07fac099.svg";